/* 
 - TODO: Explanation
*/

import { ImmutableClass, SerializableClass, SerializableConstructor, types } from "../../helpers/Util";

class AnchorProperties extends ImmutableClass {
  public properties = new Map<string, any>();

  public static fromJSON<T extends SerializableClass>(
    this: SerializableConstructor<T>,
    json: any,
  ): T {
    const blueprint = new this() as unknown as AnchorProperties;
    try {
      blueprint.properties = new Map(Object.entries(json));
    } catch (e) {
      console.error("Unable to iterate over passed in JSON: " + json);
    }
    return blueprint as unknown as T;
  }

  public getProperty(key: string) {
    return this.properties.get(key);
  }

  public setProperty(key: string, value: any) {
    return this.properties.set(key, value);
  }

  public returnAllProperties() {
    return this.properties;
  }

  public toJSObject(){
    return Object.fromEntries(this.properties)
  }

  public static deleteEntryAtPosition(map : Map<any,any>, position: number | string) {
    if (!(map instanceof Map)) {
      throw new TypeError('Expected a Map');
    }
    let index = 0;
    for (const [key] of map) {
        if (index === position) {
            map.delete(key);
            return;
        }
        index++;
    }
  }
}

export default AnchorProperties;

export const anchorKeys = ["Anatomy", "Clinician", "Code", "Location"];
